import { render } from "./ui-box-menu-sidebar.vue?vue&type=template&id=7b12cff0&scoped=true&ts=true"
import script from "./ui-box-menu-sidebar.vue?vue&type=script&lang=ts"
export * from "./ui-box-menu-sidebar.vue?vue&type=script&lang=ts"

import "./ui-box-menu-sidebar.vue?vue&type=style&index=0&id=7b12cff0&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b12cff0"]])

export default __exports__